module.exports = __webpack_public_path__ + "static/media/man_wujingyan.fbaffedb.png";